import { render, staticRenderFns } from "./OurCoursesSwiper.vue?vue&type=template&id=46b5082c&scoped=true&"
import script from "./OurCoursesSwiper.vue?vue&type=script&lang=js&"
export * from "./OurCoursesSwiper.vue?vue&type=script&lang=js&"
import style0 from "./OurCoursesSwiper.vue?vue&type=style&index=0&id=46b5082c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b5082c",
  null
  
)

export default component.exports